import axios from 'axios';

/**
 * Create an axios instance using variables from our env
 */
const hostname = process.env.VUE_APP_API_HOSTNAME;
const version = process.env.VUE_APP_API_VERSION || '';
const accessToken = process.env.VUE_APP_API_ACCESS_TOKEN;

const instance = axios.create({
    baseURL: `${hostname}/${version}/`,
    headers: {
        Authorization: `Api-Key ${accessToken}`,
    },
});

/**
 * Intercept each request and ensure it ends with a trailing slash
 */
instance.interceptors.request.use((config) => {
    if (config.url[config.url.length - 1] !== '/') config.url += '/';
    return config;
});

export default instance;
